import React from 'react'
import AdaptableProjectNote from './AdaptableProjectNote'
import './PlanningShowcase.css'

const PLANNING_URL = 'https://planning.taskpro.fr'

const PlanningShowcase = ({ onApplicationRequest }) => (
    <article className="planning-showcase-site">
        <div className="planning-showcase-copy">
            <span className="planning-signature">Une réalisation AM Services</span>
            <h3>Planning AM Services</h3>
            <h4>Les interventions, les équipes et les horaires réunis dans un planning clair.</h4>
            <p>
                Cette application métier permet de planifier les interventions, d’affecter les techniciens
                et de réorganiser rapidement la semaine par glisser-déposer. Les vues semaine, mois et tableau
                donnent à chacun le niveau de détail dont il a besoin.
            </p>
            <ul>
                <li>Planning par jour et technicien</li>
                <li>Déplacement par glisser-déposer</li>
                <li>Vues semaine, mois et tableau</li>
                <li>Ajout et modification des tâches</li>
            </ul>
            <AdaptableProjectNote />
            <div className="planning-showcase-actions">
                <a className="planning-primary" href={PLANNING_URL} target="_blank" rel="noopener noreferrer">
                    Tester la démo <span aria-hidden="true">↗</span>
                </a>
                <button type="button" className="planning-secondary" onClick={onApplicationRequest}>
                    Créer mon application métier
                </button>
            </div>
        </div>

        <a className="planning-window" href={PLANNING_URL} target="_blank" rel="noopener noreferrer" aria-label="Ouvrir Planning AM Services">
            <div className="planning-window-bar"><i></i><i></i><i></i><span>planning.taskpro.fr</span></div>
            <div className="planning-window-body">
                <div className="planning-demo-top">
                    <div className="planning-demo-logo"><b>AM</b><span><strong>AM SERVICES</strong><small>Planning d’interventions</small></span></div>
                    <em>+ Ajouter une tâche</em>
                </div>
                <div className="planning-demo-filters">
                    <small>Afficher :</small><b>Gaëtan</b><b>Eddy</b><b>Julien</b><b>Nicolas</b>
                </div>
                <div className="planning-demo-toolbar"><span>←</span><strong>Aujourd’hui</strong><span>→</span><div><b>Semaine</b><small>Mois</small><small>Tableau</small></div></div>
                <div className="planning-demo-grid">
                    <div className="planning-demo-days"><span></span><b>LUNDI</b><b>MARDI</b></div>
                    <div className="planning-demo-people"><span></span><small>Gaëtan</small><small>Eddy</small><small>Julien</small><small>Nicolas</small></div>
                    <div className="planning-demo-calendar">
                        <div className="planning-demo-hours"><span>08:00</span><span>09:00</span><span>10:00</span><span>11:00</span><span>12:00</span></div>
                        <div className="planning-demo-task first"><strong>08:00 - Maintenance</strong><small>Chaudière</small></div>
                        <div className="planning-demo-task second"><strong>09:00 - Dépannage</strong><small>Ventilation</small></div>
                    </div>
                </div>
            </div>
            <em className="planning-window-link">Explorer le planning ↗</em>
        </a>
    </article>
)

export default PlanningShowcase
